import axios from 'axios'
import stringSimilarity from 'string-similarity'

export default {
  data: function () {
    return {
      additionalFields: [],
      availableFields: [],
      conditionTypes: [
        { label: this.$t('conditions.includes'), value: 'includes' },
        { label: this.$t('conditions.not_includes'), value: 'not includes' },
        { label: this.$t('conditions.regex'), value: 'regex' },
        { label: this.$t('conditions.lower_then'), value: 'lower then' },
        { label: this.$t('conditions.greater_then'), value: 'greater then' },
        { label: this.$t('conditions.value'), value: 'value' },
        { label: this.$t('conditions.empty'), value: 'empty' },
        { label: this.$t('conditions.not_equal'), value: 'not equal' },
        { label: this.$t('conditions.not_equal_column'), value: 'not equal column' },
        { label: this.$t('conditions.not_empty'), value: 'not empty' },
        { label: this.$t('conditions.in_list'), value: 'in list' }
      ],
      feedTypes: [],
      filteringFields: [],
      isError: false,
      isLoading: true,
      isProductsLoading: true,
      isTemplatesLoading: true,
      product: {},
      ruleTypes: [
        { label: this.$i18n.t('operations.format'), value: 'format' },
        { label: this.$i18n.t('operations.replace'), value: 'replace' },
        { label: this.$i18n.t('operations.value'), value: 'value' },
        { label: this.$i18n.t('operations.regex'), value: 'regex' },
        { label: this.$i18n.t('operations.regex_match'), value: 'regex match' },
        { label: this.$i18n.t('operations.choose'), value: 'choose' },
        { label: this.$i18n.t('operations.split_nth'), value: 'split nth' },
        { label: this.$i18n.t('operations.xml'), value: 'xml' }
      ],
      sourceVariables: []
    }
  },

  methods: {
    initFeedTemplates () {
      axios.get(process.env.VUE_APP_API_ENDPOINT + '/feed/templates/')
        .then((response) => {
          if ((response.status === 201) || (response.status === 200)) {
            this.feedTypes = response.data
            this.isTemplatesLoading = false
          }
        })
        .catch((error) => {
          if (error.response) {
            this.$router.push({ name: 'auth.error', params: { errorCode: error.response.data.statusCode, errorMessage: error.response.data.message } })
          }
        })
    },

    initFeedType (feedTypeName) {
      return this.feedTypes.filter(feedType => feedType.name === feedTypeName)[0]
    },

    initSourceVariables (feedType) {
      this.isProductsLoading = true
      axios.post(process.env.VUE_APP_API_ENDPOINT + '/data/products/' + this.$route.params.projectId, {
        filterRules: [],
        orderBy: {
          field: '',
          sort: 'desc'
        },
        start: 0,
        end: 1
      })
        .then((response) => {
          if ((response.status === 201) || (response.status === 200)) {
            this.product = response.data.products[0]
            for (const property in this.product) {
              const fieldName = property.substr(0, property.indexOf('—') - 1)
              const sourceName = property.substr(property.indexOf('—') + 2, property.length - 1)
              this.sourceVariables.push({
                field: fieldName,
                labelBracket: fieldName + ' [' + sourceName + ']',
                labelDash: fieldName + ' — ' + sourceName,
                source: sourceName
              })
            }
            this.initFields(feedType)
            this.isProductsLoading = false
          }
        })
        .catch((error) => {
          if (error.response) {
            this.$router.push({ name: 'auth.error', params: { errorCode: error.response.data.statusCode, errorMessage: error.response.data.message } })
          }
        })
    },

    initFields (feedTypeName) {
      axios.get(process.env.VUE_APP_API_ENDPOINT + '/feed/template/' + feedTypeName)
        .then((response) => {
          if ((response.status === 201) || (response.status === 200)) {
            this.availableFields = response.data.fields
            this.additionalFields = [...this.availableFields]
            this.initMappingRules()
          }
        })
        .catch((error) => {
          if (error.response) {
            this.$router.push({ name: 'auth.error', params: { errorCode: error.response.data.statusCode, errorMessage: error.response.data.message } })
          }
        })
    },

    initMappingRules () {
      if (this.mappingRules.length === 0) {
        this.availableFields.forEach((field) => {
          if (field.status === 'required') this.mappingRules.push({ from: '', to: field.name })
        })
      }

      this.mappingRules.forEach((mappingRule) => {
        if (mappingRule.from === mappingRule.to) mappingRule.custom = true
        else mappingRule.custom = false
        if (mappingRule.custom) {
          mappingRule.selectedSourceVariable = mappingRule.from
          mappingRule.fromLabel = mappingRule.from
        } else {
          const sourceName = mappingRule.from.substr(mappingRule.from.indexOf('—') + 2, mappingRule.from.length - 1)
          const sourceColumn = mappingRule.from.substr(0, mappingRule.from.indexOf('—') - 1)
          mappingRule.selectedSourceVariable = this.sourceVariables.filter(sourceVariable => sourceVariable.field === sourceColumn && sourceVariable.source === sourceName)[0]
          mappingRule.fromLabel = mappingRule.from.substr(0, mappingRule.from.indexOf('—')) + ' [' + mappingRule.from.substr(mappingRule.from.indexOf('—') + 2, mappingRule.from.length - 1) + ']'
        }
        const matchingField = this.availableFields.filter(field => field.name === mappingRule.to)[0]
        if (matchingField !== undefined) {
          mappingRule.status = matchingField.status
          mappingRule.tooltip = matchingField.tooltip
        } else {
          this.availableFields.push({ name: mappingRule.to, options: [], status: 'optional', tooltip: { EN: '', PL: '' } })
          mappingRule.status = 'optional'
          mappingRule.tooltip = { EN: '', PL: '' }
        }
        mappingRule.sourceVariables = this.calculateSimilarity(mappingRule.to).sort((a, b) => b.similarity - a.similarity)
        this.additionalFields.splice(this.additionalFields.findIndex(field => field.name === mappingRule.to), 1)
      })
      if (this.currentRule !== undefined) this.initRules()
      else this.isLoading = false
    },

    initRules () {
      this.rules.forEach((rule) => {
        const matchingMappingRule = this.mappingRules.filter(mappingRule => mappingRule.to === rule.columnName)[0]
        rule.mappingRule = matchingMappingRule
        if (rule.mappingRule.custom) rule.sourceVariable = matchingMappingRule.to
        else rule.sourceVariable = matchingMappingRule.to + ' [' + matchingMappingRule.from.substr(matchingMappingRule.from.indexOf('—') + 2, matchingMappingRule.from.length - 1) + ']'
        rule.operationTypeLabel = this.ruleTypes.filter(ruleType => ruleType.value === rule.operationType)[0].label
        if (rule.toReplace === undefined) rule.toReplace = ''
        rule.conditions.forEach((condition) => {
          condition.selectedConditionType = this.conditionTypes.filter(conditionType => conditionType.value === condition.conditionType)[0]
          condition.selectedSourceVariable = this.sourceVariables.filter(sourceVariable => sourceVariable.labelDash === condition.columnName)[0]
        })
        const ruleField = this.availableFields.filter(availableField => availableField.name === rule.columnName)[0]
        if (ruleField !== undefined) {
          rule.options = ruleField.options
        } else {
          rule.options = []
        }
      })
      this.isLoading = false
    },

    initFilters (mappingRules, feedType) {
      this.isLoading = true
      this.initFilteringFields(mappingRules, feedType)

      if (this.filters.length > 0) {
        this.filters.forEach((filter) => {
          filter.conditions.forEach((condition) => {
            if (condition.columnName !== '') {
              condition.filteringField = this.filteringFields.filter(filteringField => filteringField.value === condition.columnName)[0]
            } else {
              condition.filteringField = {}
              condition.incomplete = true
            }
            if (condition.conditionType !== '') {
              condition.filteringType = this.conditionTypes.filter(conditionType => conditionType.value === condition.conditionType)[0]
            } else {
              condition.filteringType = {}
              condition.incomplete = true
            }
            condition.errors = []
          })
        })
      }
      this.isLoading = false
    },

    initTaggingRules (mappingRules, feedType) {
      this.initFilteringFields(mappingRules, feedType)
      this.taggingRules.forEach((taggingRule) => {
        if (taggingRule.value !== '') {
          taggingRule.filteringField = this.filteringFields.filter(filteringField => filteringField.value === taggingRule.value)[0]
        } else {
          taggingRule.filteringField = {}
        }
      })
    },

    initFilteringFields (mappingRules, feedType) {
      this.initSourceVariables(feedType)
      mappingRules.forEach((mappingRule) => {
        this.filteringFields.push({
          label: mappingRule.to,
          type: 'field',
          value: mappingRule.to
        })
      })

      this.sourceVariables.forEach((sourceVariable) => {
        this.filteringFields.push({
          label: sourceVariable.labelBracket,
          type: 'source',
          value: sourceVariable.labelDash
        })
      })
    },

    calculateSimilarity (fieldName) {
      const sourceVariablesWithSimilarity = []
      this.sourceVariables.forEach((sourceVariable) => {
        sourceVariable.similarity = stringSimilarity.compareTwoStrings(fieldName, sourceVariable.field)
        sourceVariablesWithSimilarity.push(sourceVariable)
      })
      sourceVariablesWithSimilarity.forEach((sourceVariableWithSimilarity) => {
        const match = this.$attrs.project.sources.find(source => {
          if ((source.name === sourceVariableWithSimilarity.source) && (source.config.primary)) return true
          else return false
        })
        if (match) sourceVariableWithSimilarity.similarity = sourceVariableWithSimilarity.similarity + 0.01
        else sourceVariableWithSimilarity.similarity = sourceVariableWithSimilarity.similarity - 0.01
      })
      return sourceVariablesWithSimilarity
    }
  }
}
